import { Project } from '@gameonly/core';

export const blocks = {
  site: {
    id: 'site',
    name: 'Sites',
    bgColor: 'var(--lightgreen)',
    barColor: 'var(--green)',
    newButtonIconColor: "black",
    borderColor: 'var(--darkblue)',
    width: '80%',
    models: ['site'],
  },
  game: {
    id: 'game',
    name: 'Jeux',
    bgColor: 'var(--lightpink)',
    barColor: 'var(--pink)',
    newButtonIconColor: "black",
    borderColor: 'var(--darkblue)',
    width: '100%',
    models: ['game'],
  },
};

export const dashboardText = {
  createButton: {
    //model as key
    site: 'site',
    game: 'jeu',
  },
  emptyBlock: {
    title: {
      //model as key
      site: 'Créez votre première année',
      game: 'Créez votre premier jeu',
    },
    description: {
      //model as key
      site: 'Empreinte environnementale annuel de votre site.',
      game: 'Empreinte environnementale de votre jeu.',
    },
  },
};

export const sortByDate = (a: Project, b: Project) => {
  return (
    (new Date(b.updatedAt) || new Date(b.createdAt)).getTime() -
    (new Date(a.updatedAt) || new Date(a.createdAt)).getTime()
  );
};

export const downloadFile = (blob: Blob, fileName: string) => {
  const anchorElement = document.createElement('a');

  document.body.appendChild(anchorElement);

  anchorElement.style.display = 'none';

  const url = window.URL.createObjectURL(blob);

  anchorElement.href = url;
  anchorElement.download = fileName;
  anchorElement.click();

  window.URL.revokeObjectURL(url);
};
